import React from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
} from "reactstrap";
import privateActions from "../../../../API/privateCalls/privateActions";
import {formatFloatString} from "../../../../utils/helperMethods";

class HistModel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      loading1: false,
      loading2: true,
      loading3: true,
      histPasandoNivelTrue: "",
      cantidadLecturas: "",
      histTiempo: "",
    };

    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState({
      modal: !this.state.modal,
    });
    this.getInfo();
  }
  getInfo() {

    privateActions
      .HistLeidas(
        localStorage.getItem("idUsuario"),
        this.props.hist.id
      )
      .then((res) => {
        this.setState({ loading2: false, cantidadLecturas: res });
      });
    privateActions
      .HistTiempo(localStorage.getItem("idUsuario"), this.props.hist.id)
      .then((res) => {
        this.setState({ loading3: false, histTiempo: res });
      });
  }
  render() {
    return (
      <span className="d-inline-block mb-2 mr-2">
        <Button color="primary" onClick={this.toggle}>
          Ver Detalle
        </Button>
        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle}
          className={this.props.className}
        >
          <ModalHeader toggle={this.toggle}>
            {this.props.hist.descripcion}
          </ModalHeader>
          <ModalBody></ModalBody>
          <Row className="d-flex justify-content-center">
            <Col md="10 ">
              <Card className="main-card mb-3">
                <CardBody>
                  <Form>
                    {this.state.loading1 ? null : this.state
                        .loading2 ? null : this.state.loading3 ? null : (
                      <div>
                        <FormGroup>
                          <Label for="exampleEmail">
                            Cantidad Lecturas
                          </Label>
                          <Input
                            value={this.state.cantidadLecturas}
                            type="email"
                            name="email"
                            disabled
                            id="exampleEmail"
                            placeholder="no se pudo cargar"
                          />
                        </FormGroup>
             
                        <FormGroup>
                          <Label for="example">Tiempo Lectura</Label>
                          <Input
                            value={formatFloatString(this.state.histTiempo)}
                            type=""
                            disabled
                            name="localidad"
                            id="flia"
                            placeholder="no se pudo cargar"
                          />
                        </FormGroup>{" "}
                      </div>
                    )}
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <ModalFooter>
            <Button color="primary" onClick={this.toggle}>
              Volver
            </Button>{" "}
          </ModalFooter>
        </Modal>
      </span>
    );
  }
}

export default HistModel;



// WEBPACK FOOTER //
// src/Pages/ObjetivosDelJuego/Historias/component/HistModel.js